import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import DepartmentManager from "../components/DepartmentManager";
import ImapConfigForm from "../components/ImapConfigForm";
import StampUpload from "../components/StampUpload";
import "./SettingsPage.css";

export default function SettingsPage() {
  const [activeTab, setActiveTab] = useState("departments");
  const navigate = useNavigate();
  const departmentData = JSON.parse(localStorage.getItem("department")) || {};
  const isSuperuser = departmentData.is_superuser || false;

  useEffect(() => {
    if (!isSuperuser) {
      navigate("/dashboard");
    }
  }, [isSuperuser, navigate]);

  if (!isSuperuser) return null;

  return (
    <div className="dash-root">
      <Header />
      <div className="dash-layout">
        <Sidebar activePage="settings" isSuperuser={isSuperuser} />

        <div className="settings-content">
          <h2 className="settings-title">პარამეტრები</h2>

          <div className="settings-tabs">
            <button
              className={`tab-btn ${activeTab === "departments" ? "active" : ""}`}
              onClick={() => setActiveTab("departments")}
            >
              დეპარტამენტები
            </button>
            <button
              className={`tab-btn ${activeTab === "imap" ? "active" : ""}`}
              onClick={() => setActiveTab("imap")}
            >
              ელ. ფოსტის დაკავშირება
            </button>
            <button
              className={`tab-btn ${activeTab === "stamp" ? "active" : ""}`}
              onClick={() => setActiveTab("stamp")}
            >
              ბეჭედი
            </button>
          </div>

          <div className="settings-panel">
            {activeTab === "departments" && <DepartmentManager />}
            {activeTab === "imap" && <ImapConfigForm />}
            {activeTab === "stamp" && <StampUpload />}
          </div>
        </div>
      </div>
    </div>
  );
}
